<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">Aggiungere coperture</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-3">
                <div class="col text-center">
                    <h6 class="regular-text red">In caso di evento malaugurato voglio coprire il piano con copertura accessoria</h6>
                </div>
            </div>

            <div class="row mb-3" >
                <div class="col d-flex justify-content-center">
                    <label class="container-checkbox">Copertura per decesso
                        <input v-model="formData.deathCoverage" @change="clearCoverageData('death')" type="checkbox" id="death-coverage" name="deathCoverage">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col d-flex justify-content-center">
                    <label class="container-checkbox">Copertura per malattia
                        <input v-model="formData.diseaseCoverage" @change="clearCoverageData('disease')" type="checkbox"  id="disease-coverage" name="diseaseCoverage">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <div class="row mb-5" v-if="(formData.deathCoverage || formData.diseaseCoverage)">
                <div class="col-sm-6">
                    <input v-model="formData.insuredFigure.firstName" type="text" class="form-control" id="firstName" placeholder="Nome" required="">
                    <label v-if="formData.insuredFigure.firstName">Nome</label> 
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.insuredFigure.lastName" type="text" class="form-control" id="lastName" placeholder="Cognome" required="">
                    <label v-if="formData.insuredFigure.lastName">Cognome</label> 
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.insuredFigure.email" type="text" class="form-control" id="email" placeholder="Email" required="">
                    <label v-if="formData.insuredFigure.email">Email</label> 
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.insuredFigure.address" type="text" class="form-control" id="address" placeholder="Indirizzo" required="">
                    <label v-if="formData.insuredFigure.address">Indirizzo</label>
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.insuredFigure.dateOfBirth"  @change="clearCoverageData();checkAge(formData.insuredFigure.dateOfBirth);" :type="formData.insuredFigure.dateOfBirth == null ? 'text' : 'date'" class="form-control" id="dateOfBirth" placeholder="Data di nascita" onfocus="(this.type='date')" required="">
                    <label v-if="formData.insuredFigure.dateOfBirth">Data di nascita</label> 
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.insuredFigure.telephone" type="number" class="form-control" id="telephone" placeholder="Telefono" required="">
                    <label v-if="formData.insuredFigure.telephone">Telefono</label> 
                </div>
                
            </div>
            <div class="row mb-5">
                <div v-if="formData.deathCoverage && checkAge(formData.insuredFigure.dateOfBirth)" class="col-sm-6">
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <input v-model="formData.deathCoverageDuration" @change="checkDeathDuration(formData.deathCoverageDuration);recalculatePremiums();" type="number" class="form-control" id="deathCoverageDuration" placeholder="Durata copertura per decesso" required="">
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" title="Minimo 5 anni, massimo pari alla durata del piano di versamenti, con limite massimo di 25 anni.">
                    </div>
                    <label v-if="formData.deathCoverageDuration">Durata anni copertura per decesso </label>
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <input v-model="formData.deathCoverageAmount" @change="checkDeathPremiumAmount(formData.deathCoverageAmount);recalculatePremiums();" type="number" class="form-control" id="deathCoverageAmount" placeholder="Premio protetto copertura per decesso" required="">
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" title="Minimo annuo Euro 3.000, massimo annuo pari al premio ricorrente scelto.">
                    </div>
                    <label v-if="formData.deathCoverageAmount">Premio protetto copertura per decesso</label>
                </div>
                <div v-if="formData.diseaseCoverage && checkAge(formData.insuredFigure.dateOfBirth)" class="col-sm-6">
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <input v-model="formData.diseaseCoverageDuration" @change="checkDiseaseDuration(formData.diseaseCoverageDuration);recalculatePremiums();" type="number" class="form-control" id="diseaseCoverageDuration" placeholder="Durata copertura per malattia" required="">
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" title="Minimo 5 anni, massimo pari alla durata del piano di versamenti, con limite massimo di 25 anni.">
                    </div>
                    <label v-if="formData.diseaseCoverageDuration">Durata anni copertura per malattia</label>
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <input v-model="formData.diseaseCoverageAmount" @change="checkDiseasePremiumAmount(formData.diseaseCoverageAmount);recalculatePremiums();" type="number" class="form-control" id="diseaseCoverageAmount" placeholder="Premio protetto copertura per malattia" required="">
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" title="Minimo annuo Euro 3.000, massimo annuo pari al premio ricorrente scelto.">
                    </div>
                    <label v-if="formData.diseaseCoverageAmount">Premio protetto copertura per malattia</label>
                </div>
            </div>
            <div class="row">
                <div class="text-center mb-3">
                    <input type="submit" value="Procedi">
                </div>
            </div>
        </form>
    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    import tcm from '@/tcm.json';
    import malattia from '@/malattia.json';
    export default {
        name: 'CoverageScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        deathCoverage: false,
                        deathCoverageDuration: null,
                        deathCoverageAmount: null,
                        deathCoverageCalculated: null,
                        diseaseCoverage: false,
                        diseaseCoverageDuration: null,
                        diseaseCoverageAmount: null,
                        diseaseCoverageCalculated: null,
                        insuredFigure: {
                            firstName: null,
                            lastName: null,
                            email: null,
                            telephone: null,
                            dateOfBirth: null,
                            address: null,
                        },
                    }
                }
            }
            
        },
        data() {
            return {
                errors: []
            }
        },
        methods: {
            recalculatePremiums() {
                // Get age
                let today = new Date();
                let dateOfBirth = new Date(this.formData.insuredFigure.dateOfBirth);
                let days = (today.getUTCFullYear() - dateOfBirth.getUTCFullYear()) * 360 + (today.getUTCMonth() - dateOfBirth.getUTCMonth()) * 30 + (today.getUTCDate() - dateOfBirth.getUTCDate());
                let age = Math.round(days/360);
                this.formData.insuredFigure.age = age;
                // Get Divisor for Total Calculation
                let divisor;
                switch (this.formData.installmentType) {
                    case 'Annuale':
                        divisor = 1;
                        break;
                    case 'Semestrale':
                        divisor = 2;
                        break;
                    case 'Trimestrale':
                        divisor = 4;
                        break;
                    case 'Mensile':
                        divisor = 12;
                        break;
                }

                // Get TCM value
                let deathCoverageRate;
                // If input has values, proceed to calculate, else set results to 0
                if ((this.formData.deathCoverageDuration) && (this.formData.deathCoverageAmount)) {
                    for (let i = 0; i < tcm.length; i++) {
                        
                        if (tcm[i].eta == age) {
                            deathCoverageRate = tcm[i][this.formData.deathCoverageDuration];
                            console.log(deathCoverageRate);
                            this.formData.deathCoverageRate = deathCoverageRate; // debug purposes only
                            this.formData.deathCoverageCalculated = this.formData.deathCoverageAmount * deathCoverageRate;
                            this.formData.deathCoverageTotal = this.formData.deathCoverageCalculated / divisor;
                        }                    
                    }
                } else {
                    this.formData.deathCoverageCalculated = 0;
                    this.formData.deathCoverageTotal = 0;
                }

                // Get Malattia value
                let diseaseCoverageRate;
                // If input has values, proceed to calculate, else set results to 0
                if ((this.formData.diseaseCoverageDuration) && (this.formData.diseaseCoverageAmount)) {
                    for (let i = 0; i < malattia.length; i++) {
                        if (malattia[i].eta == age) {
                            diseaseCoverageRate = malattia[i][this.formData.diseaseCoverageDuration];
                            this.formData.diseaseCoverageRate = diseaseCoverageRate; // debug purposes only
                            this.formData.diseaseCoverageCalculated = this.formData.diseaseCoverageAmount * diseaseCoverageRate;
                            this.formData.diseaseCoverageTotal = this.formData.diseaseCoverageCalculated / divisor;
                        }                    
                    }
                } else {
                    this.formData.diseaseCoverageCalculated = 0;
                    this.formData.diseaseCoverageTotal = 0;
                }
               
            },
            checkDeathDuration(duration) {
                // Get age
                const ageDifMs = Date.now() - new Date(this.formData.insuredFigure.dateOfBirth).getTime();
                const ageDate = new Date(ageDifMs);
                let age = Math.abs(ageDate.getUTCFullYear() - 1970);
                
                // Set min
                let min = 5;
                // Set max - use 80-age, but if 80-age is higher than plan duration, use plan duration but if plan duration is over 25, use 25.
                let max = Math.min(80 - age, Math.min(this.formData.duration, 25));

                let errorMsg = "Durata copertura per decesso non valida";
                if ((duration < min) || (duration > max)) {
                    if (!this.errors.includes(errorMsg)) {
                        this.errors.push(errorMsg);
                    }
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf(errorMsg);
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
            },
            checkDiseaseDuration(duration) {
                // Get age
                const ageDifMs = Date.now() - new Date(this.formData.insuredFigure.dateOfBirth).getTime();
                const ageDate = new Date(ageDifMs);
                let age = Math.abs(ageDate.getUTCFullYear() - 1970);
                
                // Set min
                let min = 5;
                // Set max - use 70-age, but if 70-age is higher than plan duration, use plan duration but if plan duration is over 25, use 25.
                let max = Math.min(70 - age, Math.min(this.formData.duration, 25));

                let errorMsg = "Durata copertura per malattia non valida";
                if ((duration < min) || (duration > max)) {
                    if (!this.errors.includes(errorMsg)) {
                        this.errors.push(errorMsg);
                    }
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf(errorMsg);
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
            },
            checkDeathPremiumAmount(amount) {
                let errorMsg = "Premio protetto copertura per decesso non valida";
                if ((amount < 3000) || (amount > this.formData.amountAnnual)) {
                    if (!this.errors.includes(errorMsg)) {
                        this.errors.push(errorMsg);
                    }
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf(errorMsg);
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
            },
            checkDiseasePremiumAmount(amount) {
                let errorMsg = "Premio protetto copertura per malattia non valida";
                if ((amount < 3000) || (amount > this.formData.amountAnnual)) {
                    if (!this.errors.includes(errorMsg)) {
                        this.errors.push(errorMsg);
                    }
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf(errorMsg);
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
            },
            clearCoverageData(type = null) {
                // Clear coverage values if DoB changes.
                if (type == "death") {
                    this.formData.deathCoverageDuration = null;
                    this.formData.deathCoverageRate = null;
                    this.formData.deathCoverageAmount = null;
                    this.formData.deathCoverageCalculated = 0;
                    this.formData.deathCoverageTotal = 0;
                } else
                if (type == "disease") {
                    this.formData.diseaseCoverageDuration = null;
                    this.formData.diseaseCoverageRate = null;
                    this.formData.diseaseCoverageAmount = null;
                    this.formData.diseaseCoverageCalculated = 0;
                    this.formData.diseaseCoverageTotal = 0;
                } else {
                    this.formData.deathCoverageDuration = null;
                    this.formData.deathCoverageRate = null;
                    this.formData.deathCoverageCalculated = 0;
                    this.formData.deathCoverageTotal = 0;
                    this.formData.diseaseCoverageDuration = null;
                    this.formData.diseaseCoverageRate = null;
                    this.formData.diseaseCoverageCalculated = 0;
                    this.formData.diseaseCoverageTotal = 0;
                }
            },
            checkAge(birthday) {
                // If value is undefined return false
                if (!birthday) { return false; }

                // Get age
                let today = new Date();
                let dateOfBirth = new Date(birthday);
                let days = (today.getUTCFullYear() - dateOfBirth.getUTCFullYear()) * 360 + (today.getUTCMonth() - dateOfBirth.getUTCMonth()) * 30 + (today.getUTCDate() - dateOfBirth.getUTCDate());
                let age = Math.round(days/360);

                // If age is not in range, send error, else delete error
                let errorMsg = "Età non valida";
                if ((age < 18) || (age > 78)) {
                    if (!this.errors.includes(errorMsg)) {
                        this.errors.push(errorMsg);
                    }
                    return false;
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf(errorMsg);
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
                return true;
            },
            validateForm() {
                this.errors = [];
                if (this.formData.deathCoverage || this.formData.diseaseCoverage) {
                    if (!this.formData.insuredFigure.firstName || this.formData.insuredFigure.firstName == "") {
                        this.errors.push("Nome mancante");
                    }
                    if (!this.formData.insuredFigure.lastName || this.formData.insuredFigure.lastName == "") {
                        this.errors.push("Cognome mancante");
                    }
                    if (!this.formData.insuredFigure.email || this.formData.insuredFigure.email == "") {
                        this.errors.push("Email mancante");
                    }
                    if (!this.formData.insuredFigure.telephone || this.formData.insuredFigure.telephone == "") {
                        this.errors.push("Telefono mancante");
                    }
                    if (!this.checkAge(this.formData.insuredFigure.dateOfBirth)) {}
                    if (!this.formData.insuredFigure.dateOfBirth  || this.formData.insuredFigure.dateOfBirth == "") {
                        this.errors.push("Età contraente non valida o mancante");
                    }
                    if (!this.formData.insuredFigure.address || this.formData.insuredFigure.address == "") {
                        this.errors.push("Indirizzo mancante");
                    }
                    if (this.formData.deathCoverage) {
                        if (this.checkDeathDuration(this.formData.deathCoverageDuration)) {}
                        if (this.checkDeathPremiumAmount(this.formData.deathCoverageAmount)) {}
                        if (!this.formData.deathCoverageDuration || this.formData.deathCoverageDuration == "") {
                            this.errors.push("Durata copertura per decesso mancante");
                        }
                        if (!this.formData.deathCoverageAmount || this.formData.deathCoverageAmount == "") {
                            this.errors.push("Premio protetto copertura per decesso mancante");
                        }
                        if ((this.formData.deathCoverageAmount < 3000) || (this.formData.deathCoverageAmount > this.formData.amountAnnual)) {
                            this.errors.push("Premio protetto copertura per malattia non valida");
                        }
                    }
                    
                    if (this.formData.diseaseCoverage) {
                        if (this.checkDiseaseDuration(this.formData.diseaseCoverageDuration)) {}
                        if (this.checkDiseasePremiumAmount(this.formData.diseaseCoverageAmount)) {}
                        if (!this.formData.diseaseCoverageDuration || this.formData.diseaseCoverageDuration == "") {
                            this.errors.push("Durata copertura per malattia mancante");
                        }
                        if (!this.formData.diseaseCoverageAmount || this.formData.diseaseCoverageAmount == "") {
                            this.errors.push("Premio protetto copertura per malattia mancante");
                        }
                        if ((this.formData.diseaseCoverageAmount < 3000) || (this.formData.diseaseCoverageAmount > this.formData.amountAnnual)) {
                            this.errors.push("Premio protetto copertura per malattia non valida");
                        }
                    }
                }
                
                // Save Form
                if (this.errors.length === 0)   {
                    if (this.formData.deathCoverage || this.formData.diseaseCoverage) {
                        if (this.formData.insuredFigure.firstName && this.formData.insuredFigure.lastName && this.formData.insuredFigure.email && this.formData.insuredFigure.telephone && this.formData.insuredFigure.dateOfBirth && this.formData.insuredFigure.address) {
                            if ((this.formData.deathCoverage && this.formData.deathCoverageDuration) || (this.formData.diseaseCoverage && this.formData.diseaseCoverageDuration)) {
                                this.$emit('save-form-data-event', this.formData);
                                this.$emit('go-to-event', 'ResultScreenId');
                                return true;
                            }
                        }
                    } else {
                        this.$emit('go-to-event', 'ResultScreenId');
                        return true;
                        
                    }
                }

                
                
                
            }
        }
    }
</script>